import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Button = styled.button`
  min-height: 48px;
  width: 100%;
  border-radius: 12px;
  border: none;
  background-color: ${({ backgroundcolor }) => backgroundcolor || colors.primary};
  color: ${({ color }) => color || colors.titleStrongWhite};
  font-size: 16px;
  font-family: Circular-Std-Bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    background-color: ${colors.grayBackground};
    color: ${colors.strongGray};
    cursor: not-allowed;
  }
`
